import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, Users, Globe, Receipt, Building2, Wallet, Settings, LogOut, X } from 'lucide-react';
import { useAppContext } from '../../contexts/AppContext';
import { formatCurrency } from '../../utils/formatters';
import { BillvastLogo } from '../ui/BillvastLogo';
type SidebarProps = {
  isOpen: boolean;
  onClose: () => void;
};
export const Sidebar: React.FC<SidebarProps> = ({
  isOpen,
  onClose
}) => {
  const {
    state,
    logout
  } = useAppContext();
  const {
    user
  } = state;
  const navItems = [{
    name: 'Overview',
    path: '/dashboard',
    icon: LayoutDashboard
  }, {
    name: 'Crowdfunding',
    path: '/dashboard/crowdfunding',
    icon: Users
  }, {
    name: 'Wallet',
    path: '/dashboard/wallet',
    icon: Wallet
  }, {
    name: 'Settings',
    path: '/dashboard/settings',
    icon: Settings
  }];
  const handleLogout = () => {
    logout();
  };
  return <>
      {/* Mobile Overlay */}
      {isOpen && <div className="fixed inset-0 bg-black/50 z-40 lg:hidden" onClick={onClose} data-id="element-248" />}

      <aside className={`
        fixed top-0 left-0 z-50 h-screen w-64 bg-white border-r border-gray-100 flex flex-col transition-transform duration-300 ease-in-out
        ${isOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
      `} data-id="element-249">
        {/* Logo */}
        <div className="h-16 flex items-center justify-between px-6 border-b border-gray-100 shrink-0" data-id="element-250">
          <BillvastLogo size="md" data-id="element-251" />
          <button onClick={onClose} className="lg:hidden text-gray-500 hover:text-gray-700" data-id="element-252">
            <X size={20} data-id="element-253" />
          </button>
        </div>

        {/* Navigation */}
        <nav className="flex-1 overflow-y-auto py-4 px-3 space-y-1" data-id="element-254">
          {navItems.map(item => <NavLink key={item.name} to={item.path} className={({
          isActive
        }) => `
                flex items-center gap-3 px-3 py-2.5 rounded-xl font-medium transition-colors
                ${isActive ? 'bg-brand-primary/10 text-brand-primary-dark' : 'text-brand-text-light hover:bg-gray-50 hover:text-brand-text-dark'}
              `} data-id="element-255">
              <item.icon size={20} data-id="element-256" />
              {item.name}
            </NavLink>)}
        </nav>

        {/* Bottom Section */}
        <div className="p-4 border-t border-gray-100 shrink-0" data-id="element-257">
          {/* Wallet Balance Mini Card */}
          <div className="bg-brand-primary-dark rounded-xl p-4 mb-4 text-white" data-id="element-258">
            <p className="text-brand-primary-light text-xs font-medium mb-1" data-id="element-259">
              Wallet Balance
            </p>
            <p className="text-lg font-bold" data-id="element-260">
              {formatCurrency(user?.walletBalance || 0)}
            </p>
          </div>

          {/* User Profile & Logout */}
          <div className="flex items-center justify-between" data-id="element-261">
            <div className="flex items-center gap-3" data-id="element-262">
              <img src={user?.avatar} alt={user?.name} className="w-10 h-10 rounded-full border border-gray-200" data-id="element-263" />
              <div className="overflow-hidden" data-id="element-264">
                <p className="text-sm font-semibold text-brand-text-dark truncate" data-id="element-265">
                  {user?.name}
                </p>
                <p className="text-xs text-brand-text-light truncate" data-id="element-266">
                  {user?.email}
                </p>
              </div>
            </div>
            <button onClick={handleLogout} className="p-2 text-gray-400 hover:text-brand-error transition-colors rounded-lg hover:bg-red-50" title="Logout" data-id="element-267">
              <LogOut size={18} data-id="element-268" />
            </button>
          </div>
        </div>
      </aside>
    </>;
};